import Card from "components/ConfigHotel/Card";
import {
  ButtonRow,
  FormGroup,
  FormRow,
  Input,
  Label,
} from "../../Hotel/StyledHotel";
import React from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useAddPreStayMutation } from "actions/configurationAvance/PreStay/mutations";
import { ToastContainer, toast } from "react-toastify";

function PreStay() {
  const { handleSubmit, register } = useForm({});

  const { hotelId } = useParams();

  const [ADDPRESTAY, { isLoading }] = useAddPreStayMutation();

  const onSubmit = async (data) => {
    try {
      const res = await ADDPRESTAY({ ...data, hotel: hotelId });
      if (res.error) {
        toast.error("Une erreur est survenue lors de la soumission.");
      } else {
        toast.success("Enregistrement réussi");
        console.log({ res });
      }
    } catch (err) {
      console.error("Erreur lors de la soumission:", err);
      toast.error("Une erreur inattendue est survenue.");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ToastContainer className="mt-5" />
      <Card title="Pre-stay">
        <FormRow>
          <FormGroup>
            <Label>Envoi de l'email X jour avant l'arrivée</Label>
            <Input type="number" defaultValue="0" {...register("envoi_mail_x_jour_avant_arrive")} />
          </FormGroup>
          <FormGroup>
            <Label>Arrêt de l'envoi du mail pre-stay minimum X jours avant le séjour</Label>
            <Input type="number" defaultValue="1" {...register("arret_envoi_mail_x_jour_avant_sejour")} />
          </FormGroup>
        </FormRow>
        <FormRow>
          <FormGroup>
            <Label>Heure d'envoi</Label>
            <Input type="time" defaultValue="11:00" {...register("heure_envoi")} />
          </FormGroup>
        </FormRow>
        <ButtonRow>
        <button className="btn" type="button">Annuler</button>
          <button className="btn" type="submit">
            {isLoading ? "En cours..." : "Sauvegarder"}
          </button>
        </ButtonRow>
      </Card>
    </form>
  );
}

export default PreStay;
